import { InternalAccountsApiListInternalAccountTransactionsRequest } from "@wingspanhq/wingspan-api-sdk";
import { TRANSACTION_STATUS_FILTER_ALL } from "./config";
import { InternalAccountTransactionsFilter } from "./types";

export function createListRequest(
  internalAccountId: string,
  filter?: InternalAccountTransactionsFilter
): InternalAccountsApiListInternalAccountTransactionsRequest {
  const request: InternalAccountsApiListInternalAccountTransactionsRequest = {
    internalAccountId
  };

  const status = filter?.status;
  if (status && status !== TRANSACTION_STATUS_FILTER_ALL) {
    request.filter = { status: { eq: status } };
  }

  return request;
}
